<div class="d-print-none">
  <abi-back-button></abi-back-button>
  <button abiPrint>{{ 'System.Print' | translate }}</button> <!--[beforePrint]="print.bind(this)"-->
  <!--button *ngIf="canDelete()" type="button" class="btn btn-primary" (click)="delete(deleteDlg)">
    <i class="fas fa-trash-alt"></i> Delete</button-->
</div>

<abi-spinner *ngIf="!invoice"></abi-spinner>
<div class="">
  <h4 class="header-txt text-center">{{ noteName|uppercase }}
      <!--img [src]="'assets/logos-big/' + 'kic' + '.svg?v=1'" class="header-logo" [alt]="'tenant'" /-->
  </h4>

</div>
<div class="card" *ngIf="invoice">
  <div class="card-header pb-0">

    <div class="row">
      <div class="col line-breaker">
        <strong>{{ invoice.resource.contact.companyName || (invoice.resource.contact | contact) }}</strong>
        <br>
        <span class="line-breaker">
          {{ invoice.resource.address | address }}
        </span>
        <br>

        <dl class="row line-breaker">
          <dt class="col-4">Vat No.</dt>
          <dd class="col-8">: {{ invoice.resource.vatCode }}</dd>
        </dl>

      </div>
      <div class="col">
        <dl class="row">
          <dt class="col-4">Date</dt>
          <dd class="col-8">: {{ invoice.invoiceDate | date }}</dd>

          <dt class="col-4">Invoice #</dt>
          <dd class="col-8">: {{ invoice.invoiceNumber }}</dd>

          <dt class="col-4">Technician</dt>
          <dd class="col-8">: {{ invoice.resource.code }}</dd>
<!--
          <dt class="col-4">Tel Office</dt>
          <dd class="col-8">: {{ invoice.resource.contact.officeHours }}</dd>

          <dt class="col-4">Tel Mobile</dt>
          <dd class="col-8">: {{ invoice.resource.contact.mobile }}</dd>

          <dt class="col-4">e-mail</dt>
          <dd class="col-8">: {{ invoice.resource.contact.emailAddress }}</dd>
-->
        </dl>
      </div>
    </div>
    <mat-divider></mat-divider>

    <div class="row">
      <div class="col line-breaker">
        <strong>{{ companyName }}</strong>
        <br/> {{ addressLine1 }}
        <br/> {{ addressLine2 }}
        <br/> {{ addressLine3 }}, {{ postalCode }}

        <dl class="row line-breaker">
          <dt class="col-4">Vat No.</dt>
          <dd class="col-8">: {{ vatNumber }}</dd>
        </dl>
      </div>
      <div class="col">&nbsp;</div>
    </div>
  </div>
  <div class="tzable-responsive">
    <table class="table table-hover table-striped">
      <thead>
        <tr>
          <th>Line</th>
          <th class="w-60">Type</th>
          <!--th>Code</th>
          <th>Description</th-->
          <th class="text-right">Qty</th>
          <th class="text-right">Price</th>
          <!--th class="text-right">Discount</th-->
          <th class="text-right">Amount</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let line of invoice.lines; let idx = index">
          <td class="text-center">{{ idx + 1 }}</td>
          <td class="w-60">{{ line.itemId }} </td>
          <!--td>{{ line.description }} - {{ line.itemId }} </td-->
          <td class="text-right">{{ line.delivered }}</td>
          <td class="text-right">{{ line.price | number:"1.2-2" }}</td>
          <!--td class="text-right">{{ 0 }}</td-->
          <td class="text-right">{{ line.price * line.delivered | number:"1.2-2" }}</td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td colspan="2"></td>
          <td colspan="2">
            <strong>Sub-Total</strong>
          </td>
          <td class="text-right">{{ subTotal() | number:'1.2-2' }}</td>
        </tr>
        <tr>
          <td colspan="2"></td>
          <td colspan="2">
            <strong>VAT</strong>
          </td>
          <td class="text-right">{{ vat() | number:'1.2-2' }}</td>
        </tr>
        <tr>
          <td colspan="2"></td>
          <td colspan="2">
            <strong>Total</strong>
          </td>
          <td class="text-right">{{ subTotal() + vat() | number:'1.2-2' }}</td>

        </tr>
      </tfoot>
    </table>
  </div>
</div>
